<template>
  <section>
    <v-container fluid>
      <EntityHeader :pageData="pageData" :getData="getData" :getSearch="getSearch" />

      <v-row>
         <v-col cols="12" sm="12">
          <DynamicTable :isLoading="pageData.isLoading" :data="pageData.rows" :header="pageData.tableHeader"
            :option="pageData.options" :editValueMethod="edit" :pageData="pageData" :deleteValueMethod="deleteMethod"
            :restoreValueMethod="restoreMethod">
            <template v-slot:td="{ row, header }">
              <div v-if="header.key == 'slot_category'">
                {{ row[`name_${$i18n.locale}`] }}
              </div>
            </template>
          </DynamicTable>
        </v-col>

      </v-row>

      <v-row v-if="!pageData.isLoading">
        <v-col cols="12" sm="12">
          <Pagination :pagination="pageData.pagination" :limit="pageData.rowsNumber" :backValueMethod="changePage"
            :isLoading="pageData.isLoading"></Pagination>
        </v-col>
      </v-row>

    </v-container>
  </section>
</template>

<script>
import EntityHeader from "@/components/ui/EntityHeader.vue";
import Pagination from "@/components/ui/Pagination.vue";
import DynamicTable from "@/components/DynamicTable.vue";
export default {
  name: "BlogEntity",

  data: () => ({
    pageData: {
      screen_code: "02-014",
      url: null,
      controlRoute: "website/blog-control",
      entityName: null,
      main: null,
      category: null,
      isLoading: true,
      isTrashed: 1,
      rowsNumber: 15,
      tableHeader: [],
      search: "",
      rows: [],
      options: {},
      page: 1,
      pagination: {},
    },
  }),

  computed: {},

  mounted() {
    this.pageMainData();
    this.getData();
  },

  methods: {


    pageMainData() {
      this.pageData.main = this.$global.FilterPermissions(this.pageData.screen_code).main_title;
      this.pageData.category = this.$global.FilterPermissions(this.pageData.screen_code).cat_title;
      this.pageData.entityName = this.$global.FilterPermissions(this.pageData.screen_code).sub_title;
      this.pageData.url = this.$global.FilterPermissions(this.pageData.screen_code).url;

      this.pageData.tableHeader = [
        { text: "#", key: "id", type: 'text', classes: "" },
        { text: "العنوان", key: "title_ar", type: 'text', classes: "" },
        { text: "Title", key: "title_en", type: 'text', classes: "" },
        { text: "category", key: "slot_category", type: 'slot', classes: "" },
        { text: "image", key: "image", type: 'img', classes: "" },
        { text: "add date", key: "add_date", type: 'date', classes: "" },
        { text: "actions", key: "id", type: 'actions', classes: "" },
      ];

      this.pageData.options = {
        print: this.$global.CheckAction(this.pageData.screen_code, 5),
        delete: this.$global.CheckAction(this.pageData.screen_code, 4),
        edit: this.$global.CheckAction(this.pageData.screen_code, 3),
        restore: this.$global.CheckAction(this.pageData.screen_code, 4),
        view: this.$global.CheckAction(this.pageData.screen_code, 1),
      };
    },

    getSearch(word) {
      this.pageData.search = word ? word : "";
      this.getData();
    },

    getData(applayLoading = true) {
      if (this.$global.CheckAction(this.pageData.screen_code, 1)) {
        applayLoading && (this.pageData.isLoading = true);
        this.$api.GET_METHOD(`blogs?active=${this.pageData.isTrashed}&rows=${this.pageData.rowsNumber}&page=${this.pageData.page}&word=${this.pageData.search || ""}`)
          .then((response) => {
            this.pageData.isLoading = false;
            if (response.check) {
              this.pageData.entityName = this.pageData.isTrashed == 0 ? this.$i18n.t("deleted from") + " " + this.$store.state.activeScreen.sub_title
                : this.$store.state.activeScreen.sub_title;
              this.pageData.rows = response.data.items.data;
              this.pageData.page = response.data.items.current_page;
              this.pageData.pagination = {
                page: response.data.items.current_page,
                totalPages: response.data.items.last_page,
                per_page: response.data.items.per_page,
                totalRows: response.data.items.total,
              };

            }
          });
      } else {
        this.$router.push("/");
      }
    },

    changePage(page, limit) {
      console.log("page");
      this.pageData.page = page;
      this.pageData.rowsNumber = limit;
      this.getData();
    },

    deleteMethod(id) {
      console.log(id);
      this.$api.POST_METHOD(`blogs/${id}`, { _method: "delete" }).then((response) => {
        if (response.check) {
          this.getData(false);
        }
      });
    },

    restoreMethod(row) {
      this.$api.POST_METHOD(`blog_toggle/${row.id}`, null).then((response) => {
        if (response.check) {
          this.getData(false);
        }
      });
    },

    edit(row) {
      console.log("edit", row);
      this.$router.push(`/${this.pageData.controlRoute}/` + row.id);
    },

  },

  components: {
    EntityHeader,
    Pagination,
    DynamicTable
  },

};
</script>
